import React from 'react';
import { motion } from 'framer-motion';
import { childern } from '../helpers/animation';
import { experienceAnimations } from '../helpers/animation';
import { useScroll } from '../helpers/scrollAnimations';

const Experience = () => {
	const [element, controls] = useScroll();
	return (
		<motion.div
			animate={controls}
			ref={element}
			initial="hidden"
			variants={experienceAnimations}
			id="experience"
			className="section experience"
		>
			<motion.div className="skills">
				<h3>Technologies</h3>
				<ul>
					<motion.li variants={childern}>
						{}Fluent in <span className="red"> HTML,</span>{' '}
						<span className="blue">CSS</span> and{' '}
						<span className="yellow">JS.</span>
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						Version control with <span className="red"> git.</span>{' '}
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						Good handling of <span className="blue">CSS preprocessors.</span>
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						Strong knowledge of <span className="blue"> React </span>and{' '}
						<span className="green">NodeJS.</span>{' '}
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						Knowledge of <span className="blue">Redux </span> and{' '}
						<span className="blue"> Context API.</span>{' '}
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						<span className="green"> MongoDB</span>/
						<span className="blue">MySQL.</span>{' '}
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						<span className="blue">Photoshop</span>/{' '}
						<span className="red"> Illustrator</span> and Figma.{' '}
					</motion.li>
				</ul>
			</motion.div>
			<motion.div className="soft-skills">
				<h3>Skills</h3>
				<ul>
					<motion.li variants={childern}>
						{' '}
						Critical thinking and problem solving.{' '}
					</motion.li>
					<motion.li variants={childern}>
						{' '}
						Teamworking, intercultural fluency.{' '}
					</motion.li>
					<motion.li variants={childern}>
						Professional attitude and work ethic.
					</motion.li>
				</ul>
			</motion.div>
		</motion.div>
	);
};

export default Experience;
